// axiosConfig.js
import axios from 'axios';
// const API_BASE_URL = 'http://localhost:8000/';  // Replace with your actual backend URL
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
// const API_BASE_URL = 'http://172.17.0.2/';

const instance = axios.create({
  baseURL: API_BASE_URL,
  // other Axios configurations...
});

export default instance;
